// action_abandoned for the shared edit dialogs: the popup was shown, the user changed something,
// and it closed without a successful save-type API call (see actionCount in ./index.js).
// Use: mixins: [uxDialogMixin] and <dx-popup @shown="uxShown" @hidden="uxHidden">.
import Form from 'devextreme/ui/form';
import { trackUx, actionCount } from './index.js';

let lastUserInput = 0;
try {
  const mark = (e) => {
    if (e.isTrusted) lastUserInput = Date.now();
  };
  document.addEventListener('keydown', mark, true);
  document.addEventListener('pointerdown', mark, true);
} catch {
  /* no DOM */
}

function el(x) {
  return x?.nodeType ? x : x?.[0] || null;
}

export const uxDialogMixin = {
  methods: {
    uxShown(e) {
      try {
        this.uxCleanup();
        const content = el(e?.component?.content?.());
        if (!content) return;
        const st = { dirty: false, actions: actionCount(), forms: new Set(), off: [] };
        this.__ux = st;
        const onInput = (ev) => {
          if (ev.isTrusted) st.dirty = true;
        };
        content.addEventListener('input', onInput, true);
        st.off.push(() => content.removeEventListener('input', onInput, true));
        const onField = () => {
          if (Date.now() - lastUserInput < 1500) st.dirty = true;
        };
        const scan = () => {
          content.querySelectorAll('.dx-form').forEach((f) => {
            const inst = Form.getInstance(f);
            if (!inst || st.forms.has(inst)) return;
            st.forms.add(inst);
            inst.on('fieldDataChanged', onField);
            st.off.push(() => {
              try {
                inst.off('fieldDataChanged', onField);
              } catch {
                /* disposed */
              }
            });
          });
        };
        scan();
        st.timer = setTimeout(scan, 600);
      } catch {
        /* never throw */
      }
    },
    uxHidden() {
      try {
        const st = this.__ux;
        if (st && st.dirty && actionCount() === st.actions) {
          trackUx('action_abandoned', { meta: { form: String(this.title || this.$options.name || 'dialog') } });
        }
      } catch {
        /* never throw */
      }
      this.uxCleanup();
    },
    uxCleanup() {
      const st = this.__ux;
      if (!st) return;
      clearTimeout(st.timer);
      st.off.forEach((f) => f());
      this.__ux = null;
    },
  },
  beforeUnmount() {
    this.uxCleanup();
  },
};
